import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NotificationService } from 'src/app/admin/servicies/notification.service';
import { AdminSettingsService } from 'src/app/admin/servicies/admin-settings.service';
import { PhonePipe } from 'src/app/pipes/usnumberformat.pipe';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { NotificationResponseModel, NotificationTemplateResponseModel } from 'src/app/shared/models/response/notificationinapp-response-model';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { SettingsResponseModel } from 'src/app/shared/models/response/settings-response';
import { NotificationSubTemplateResponseModel } from 'src/app/shared/models/response/settings/self-scheduling-config-model/notification-subtemplate-response-model';

@Component({
  selector: 'app-preview-template',
  templateUrl: './preview-template.component.html',
  styleUrls: ['./preview-template.component.sass'],
  standalone: false
})
export class PreviewTemplateComponent extends BaseComponent implements OnInit {
  emailTextArea: string;
  emailTitle: string;
  subject: string;
  notificationList: NotificationResponseModel[];
  settingsResponseModel: Array<SettingsResponseModel>;
  smsTextArea: string;
  smsTitle: string;
  templateType = 'Email';

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    dynamicDialogConfig: DynamicDialogConfig,
    messageService: MessageService,
    private notificationService: NotificationService,
    private settingsService: AdminSettingsService
  ) {
    super(messageService);
    let { roleId, type, templateType, subTemplate } = dynamicDialogConfig.data;
    if (subTemplate == null) {
      this.getInvitationTemplates(roleId, type, templateType);
    }
    else{
      this.templateType = templateType == 'Email' ? 'Email' : 'SMS';
      templateType == 'Email' ? this.viewSubEmail(subTemplate) : this.viewSubSMS(subTemplate);
    }
  }
  ngOnInit(): void {
    this.getApplicationSettings();
  }

  private getInvitationTemplates(roleId: number, type: string, templateType: string) {
    this.loading = true;
    this.notificationService.GetInvitationTempates(roleId, type)
      .subscribe((result: ResultOfT<NotificationResponseModel[]>) => {
        this.processResult<any>(result, () => {
          this.notificationList = result.responseModel;
          let template = this.notificationList[0].notificationTemplate.find(x => x.appEnumnotificationType == templateType);
          this.templateType = templateType == 'Email' ? 'Email' : 'SMS';
          templateType == 'Email' ? this.viewEmail(template, this.notificationList[0]) : this.viewSMS(template, this.notificationList[0]);
        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  private async getApplicationSettings() {
    this.loading = true;
    this.settingsService.getAllSettings()
      .subscribe((result: ResultOfT<any>) => {
        this.processResult<any>(result, () => {
          this.settingsResponseModel = result.responseModel;
        });
      }, (httpResponseError) => {

        this.showErrorMessage(httpResponseError.message);
      });
  }

  close(result: any) {
    setTimeout(() => {
      this.dynamicDialogRef.close(result);
    }, 1);
  }

  viewEmail(template: NotificationTemplateResponseModel, notification: NotificationResponseModel) {
    this.subject = "";
    this.emailTitle = this.formatString(notification.appNotificationEventName);
    if (template) {
      let textArea = template.appNotificationTemplateFormat;
      let DMENumber = this.settingsResponseModel?.find(x => x.schSettingKey == 'DMENumber');
      if (DMENumber) {
        let number = DMENumber.schSettingValue.replaceAll('-', '').replaceAll('_', '');
        if (number.length > 0) {
          let phonePipe = new PhonePipe();
          textArea = textArea.replace('DMEPhone', phonePipe.transform(number));
        }
      }

      let DMEEmail = this.settingsResponseModel?.find(x => x.schSettingKey == 'DMEEmail');
      if (DMEEmail && DMEEmail.schSettingValue.length > 0) {
        textArea = textArea.replace('DMEEmail', DMEEmail.schSettingValue);
      }
      textArea = textArea.replaceAll('##', '');
      this.emailTextArea = textArea;
      this.subject = template.appNotificationTemplateSubject;
    }
  }

  viewSMS(template: NotificationTemplateResponseModel, notification: NotificationResponseModel) {
    this.smsTitle = this.formatString(notification.appNotificationEventName);
    if (template) {
      let textArea = template.appNotificationTemplateFormat;
      let DMENumber = this.settingsResponseModel?.find(x => x.schSettingKey == 'DMENumber');
      if (DMENumber) {
        let number = DMENumber.schSettingValue.replaceAll('-', '').replaceAll('_', '');
        if (number.length > 0) {
          let phonePipe = new PhonePipe();
          textArea = textArea.replace('DMEPhone', phonePipe.transform(number));
        }
      }

      let DMEEmail = this.settingsResponseModel?.find(x => x.schSettingKey == 'DMEEmail');
      if (DMEEmail && DMEEmail.schSettingValue.length > 0) {
        textArea = textArea.replaceAll('DMEEmail', DMEEmail.schSettingValue);
      }
      textArea = textArea.replace('##', '');
      this.smsTextArea = textArea;
    }
  }

  viewSubEmail(template: NotificationSubTemplateResponseModel) {
    this.subject = "";
    this.emailTitle = this.formatString(template.appNotificationEventName);
    if (template) {
      let textArea = template.appNotificationEmailTemplateFormat;
      let DMENumber = this.settingsResponseModel?.find(x => x.schSettingKey == 'DMENumber');
      if (DMENumber) {
        let number = DMENumber.schSettingValue.replaceAll('-', '').replaceAll('_', '');
        if (number.length > 0) {
          let phonePipe = new PhonePipe();
          textArea = textArea.replace('DMEPhone', phonePipe.transform(number));
        }
      }

      let DMEEmail = this.settingsResponseModel?.find(x => x.schSettingKey == 'DMEEmail');
      if (DMEEmail && DMEEmail.schSettingValue.length > 0) {
        textArea = textArea.replace('DMEEmail', DMEEmail.schSettingValue);
      }
      textArea = textArea.replaceAll('##', '');
      this.emailTextArea = textArea;
      this.subject = template.appNotificationTemplateSubject;
    }
  }

  viewSubSMS(template: NotificationSubTemplateResponseModel) {
    this.smsTitle = this.formatString(template.appNotificationEventName);
    if (template) {
      let textArea = template.appNotificationSMSTemplateFormat;
      let DMENumber = this.settingsResponseModel?.find(x => x.schSettingKey == 'DMENumber');
      if (DMENumber) {
        let number = DMENumber.schSettingValue.replaceAll('-', '').replaceAll('_', '');
        if (number.length > 0) {
          let phonePipe = new PhonePipe();
          textArea = textArea.replace('DMEPhone', phonePipe.transform(number));
        }
      }

      let DMEEmail = this.settingsResponseModel?.find(x => x.schSettingKey == 'DMEEmail');
      if (DMEEmail && DMEEmail.schSettingValue.length > 0) {
        textArea = textArea.replaceAll('DMEEmail', DMEEmail.schSettingValue);
      }
      textArea = textArea.replace('##', '');
      this.smsTextArea = textArea;
    }
  }


  formatString(formatStr) {
    return formatStr.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
}
